export default __webpack_public_path__ + "static/media/loading.eeefe777.gif";